<div class="w-full h-full relative">
  <div id="wizard-content">
    <div class="flex flex-col items-center justify-center">
      <div class="grid">
        <div class="flex flex-col items-center justify-center max-w-md mx-auto p-8">
          <div class="w-full flex flex-col gap-4">
            <div class="flex">
              <sbnb-icon-dynamic-pricing [size]="32"></sbnb-icon-dynamic-pricing>
            </div>
            <h2 class="text-2xl font-semibold m-0">Dynamic pricing is only available on desktop (for now)</h2>
            <div class="flex flex-col gap-2">
              <p class="text-night text-base m-0">
                You'll need to switch to a larger desktop device to preview and set up dynamic pricing. We're working on
                bringing this to smaller devices soon!
              </p>
            </div>

            <sbnb-button
              [type]="'secondary'"
              [fullWidth]="true"
              [label]="'Go back'"
              (click)="closeModal()"></sbnb-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
